import { Component, Input } from '@angular/core';
import {CompetitorViewData, AmountStatus} from "@model";

@Component({
  selector: 'app-competitor-field-output',
  templateUrl: './competitor-field-output.component.html',
  styleUrl: './competitor-field-output.component.scss',
  standalone: false
})
export class CompetitorFieldOutputComponent {
  @Input() competitor: CompetitorViewData | undefined;
  @Input() key: string |( keyof CompetitorViewData )| undefined;
  @Input() isAdmin: boolean = false;
  @Input() simpleText: boolean = false;
  @Input() fieldType: "general" | "custom" | "pricing" = "general"
  @Input() showAsPlain: boolean = true;
  @Input() showTooltip: boolean = false;

  ngOnInit() {

  }
  protected readonly AmountStatus = AmountStatus;
}
